import { render, staticRenderFns } from "./PregnancyCalendar.vue?vue&type=template&id=5ca6df66&"
import script from "./PregnancyCalendar.vue?vue&type=script&lang=js&"
export * from "./PregnancyCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports